import { render, staticRenderFns } from "./MArticles.vue?vue&type=template&id=1a410328&"
import script from "./MArticles.vue?vue&type=script&lang=ts&"
export * from "./MArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports